<script>
import Endpoints from '../../common/Endpoints'
import Request from '../../common/Request'

export default {
    init: async payload => {
        if (payload.$session.get('user')) {
            let response = await Request.do(payload, 'GET', Request.getDefaultHeader(payload), {}, `${Endpoints.systemUsers.getMe}`)
            if (response && response.data) {
                response = response.data
                payload.user = response.result
                payload.user.serviceTypes = response.result.companyUser.company.typeService
            }
        }
    },
    methods: {
        hasType: function (type) {
            if (this.user) {
                return this.user.serviceTypes.findIndex(x => x == type) > -1
            } else {
                return false
            }
        },
        isAdminMaster: function () {
            if (this.user) {
                return this.user.companyUser && this.user.companyUser.subtype === 'ADMIN_MASTER'
            }
            return false
        },
        to: function (path) {
            this.$router.push({ path: path })
        },
    },
}
</script>
